<div class="filters-row" style="display: flex;  gap: 16px">
  <div class="filter-container" [style.--dropdown-width]="data?.dropdownWidth"
    [style.--dropdown-height]="data?.dropdownHeight" [class.center-aligned]="isYearDropdown">
    <label class="filter-label">{{ data?.name }}</label>
    <ng-select [items]="filteredOptions" [multiple]="data?.isMultiSelect" [closeOnSelect]="false" [(ngModel)]="selected"
      [searchable]="false" [clearable]="false" [placeholder]="'All'" (change)="onChange($event)"
      (close)="onDropdownClose()">
      <ng-template ng-multi-label-tmp let-items="items">
        <div class="selection-count-override">
          {{ isAllSelected ? 'All' : (items.length > 1 ? ('Multiple Selections') : (items.length === 1 ? items[0] : ''))
          }}
        </div>
      </ng-template>

      <ng-template ng-header-tmp>
        <div class="custom-header">
          <!-- Search input -->
          <div class="search-wrapper">
            <!-- <mat-icon class="search-icon" fontIcon="search"></mat-icon> -->
            <input type="text" class="search-input" placeholder="Search" [formControl]="searchCtrl"
              (keydown)="$event.stopPropagation()" />
          </div>


          <div class="custom-option" *ngIf="data?.isMultiSelect">
            <input type="checkbox" id="select-all" [checked]="isAllSelected" (change)="toggleSelectAll($event)" />
            <label for="select-all">Select All</label>
          </div>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index">
        <div [title]="item" (click)="onItemClick($event, item)">
          <input id="item-{{ index }}" type="checkbox" [checked]="isItemSelected(item)" [matTooltip]="item"
            matTooltipPosition="right" />
          {{ item }}
        </div>
      </ng-template>

      <!-- removed old multi-label-tmp -->
    </ng-select>
  </div>